import { TableHeader } from '@/components/ui/table';

export function CyclesTotalHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      Total Cycles
    </TableHeader>
  );
}
